<template>
    <PageContent>
        <!-- 125550 use them as customer -->
        <NotReady v-if="!ready" />
        <div v-else>
            <PageTitle>Order Summary for
                {{$route.query.FirstDate?$root.moment($route.query.FirstDate,'MM/DD/YYYY').format('MM/DD/YYYY'):$root.moment().startOf('week').day(0).format('MM/DD/YYYY')}}
                thru
                {{$route.query.FirstDate?$root.moment($route.query.FirstDate,'MM/DD/YYYY').endOf('week').format('MM/DD/YYYY'):$root.moment().endOf('week').format('MM/DD/YYYY')}}
            <Help /></PageTitle>
            <div class="row">
                <div class="col text-center">
                    <a :href="`/OrderSummary/?SummaryType=${$route.query.SummaryType?$route.query.SummaryType:'LOCATION'}&FirstDate=${
                        ($route.query.FirstDate?
                            $root.moment($route.query.FirstDate,'MM/DD/YYYY').subtract(1,'week').format('MM/DD/YYYY'):
                            $root.moment().subtract(1,'week').day(0).format('MM/DD/YYYY'))
                    }`" class="btn btn-secondary btn-sm ms-1 me-1 mt-1 mb-1 d-block d-sm-inline-block" data-intro="View previous week">Previous Week</a>

                    <a :href="`/OrderSummary/?SummaryType=LOCATION&FirstDate=${$route.query.FirstDate?$route.query.FirstDate:$root.moment().startOf('week').day(0).format('MM/DD/YYYY')}`" class="btn btn-secondary btn-sm  ms-1 me-1 mt-1 mb-1 d-block d-sm-inline-block"  data-intro="View orders by location">Location Level</a>

                    <a :href="`/OrderSummary/?SummaryType=ITEM&FirstDate=${$route.query.FirstDate?$route.query.FirstDate:$root.moment().startOf('week').day(0).format('MM/DD/YYYY')}`" class="btn btn-secondary btn-sm  ms-1 me-1 mt-1 mb-1 d-block d-sm-inline-block" data-intro="View ordered items">Item Level</a>

                    <a :href="`/OrderSummary/?SummaryType=${$route.query.SummaryType?$route.query.SummaryType:'LOCATION'}&&FirstDate=${
                        ($route.query.FirstDate?
                            $root.moment($route.query.FirstDate,'MM/DD/YYYY').add(1,'week').format('MM/DD/YYYY'):
                            $root.moment().add(1,'week').day(0).format('MM/DD/YYYY'))
                    }`" class="btn btn-secondary btn-sm  ms-1 me-1 mt-1 mb-1 d-block d-sm-inline-block"  data-intro="View next week">Next Week</a>

                </div>
            </div>
            <hr>
            <div class="text-end mb-2">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" type="button" id="printList" data-bs-toggle="dropdown" aria-expanded="false" data-intro="View PDF">
                        Print
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="printList">
                        <li v-if="!$route.query.SummaryType||$route.query.SummaryType=='LOCATION'"><a target="_blank"  class="dropdown-item" :href="`${$store.state.api}/pdfs/ordersummaryLocation.php?lccustno=${$root.getCustomerNumber()}&token=${$store.state.localStorage.token}&SummaryType=LOCATION&FirstDate=${$root.moment($route.query.FirstDate).day(0).format('MM/DD/YYYY')}&LastDate=${$root.moment().endOf('week').format('MM/DD/YYYY')}`">PDF</a></li>
                        <li v-if="$route.query.SummaryType=='ITEM'"><a target="_blank"  class="dropdown-item" :href="`${$store.state.api}/pdfs/ordersummaryItem.php?lccustno=${$root.getCustomerNumber()}&token=${$store.state.localStorage.token}&SummaryType=${$route.query.SummaryType}&FirstDate=${$root.moment($route.query.FirstDate).day(0).format('MM/DD/YYYY')}&LastDate=${$root.moment().endOf('week').format('MM/DD/YYYY')}`">PDF</a></li>
                    </ul>
                </div>
            </div>
            <br>

            <!-- ======================= LOCATION DataTable ======================= -->
            <div v-if="$route.query.SummaryType==undefined||$route.query.SummaryType=='LOCATION'">
                <DataTable
                    :options="locationTableOptions"
                    :columns="locationColumns"
                    ref="locationTable"
                    class="display table table-sm table-striped table-bordered"
                >
                    <thead>
                        <tr>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Route</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Location</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Description</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Monday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Tuesday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Wednesday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Thursday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Friday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Saturday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Total</th>
                        </tr>
                        <tr>
                            <td><label class="filter-label">Route</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchLocationColumn(0, $event)" /></td>
                            <td><label class="filter-label">Location</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchLocationColumn(1, $event)" /></td>
                            <td><label class="filter-label">Description</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchLocationColumn(2, $event)" /></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </thead>

                    <!-- Route -->
                    <template #column-0="{ rowData }">
                        {{ rowData['route no_'] }}
                    </template>
                    <!-- Location -->
                    <template #column-1="{ rowData }">
                        {{ rowData['location no_'] }}
                    </template>
                    <!-- Description -->
                    <template #column-2="{ rowData }">
                        {{ rowData['name'] }}
                    </template>
                    <!-- Monday -->
                    <template #column-3="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['M']=='false'">
                            <div v-if="rowData.monday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'monday', ...rowData})">View ({{rowData.monday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(1).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.monday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'monday', ...rowData})">View ({{rowData.monday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Tuesday -->
                    <template #column-4="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['T']=='false'">
                            <div v-if="rowData.tuesday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'tuesday', ...rowData})">View ({{rowData.tuesday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(2).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.tuesday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'tuesday', ...rowData})">View ({{rowData.tuesday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Wednesday -->
                    <template #column-5="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['W']=='false'">
                            <div v-if="rowData.wednesday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'wednesday', ...rowData})">View ({{rowData.wednesday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(3).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.wednesday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'wednesday', ...rowData})">View ({{rowData.wednesday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Thursday -->
                    <template #column-6="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['R']=='false'">
                            <div v-if="rowData.thursday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'thursday', ...rowData})">View ({{rowData.thursday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(4).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.thursday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'thursday', ...rowData})">View ({{rowData.thursday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Friday -->
                    <template #column-7="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['F']=='false'">
                            <div v-if="rowData.friday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'friday', ...rowData})">View ({{rowData.friday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(5).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.friday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'friday', ...rowData})">View ({{rowData.friday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Saturday (visibility controlled by columnDefs) -->
                    <template #column-8="{ rowData }">
                        <div v-if="rowData['past_add_cut'] && rowData['past_add_cut']['S']=='false'">
                            <div v-if="rowData.saturday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'saturday', ...rowData})">View ({{rowData.saturday_count}})</a></div>
                            <div v-else-if="$root.getCustomerValue('Web Orders Allowed Count')>0">
                                <a v-if="checkAccountStatusBool()" target="_blank" :href="`/orders/${rowData['route no_']}/${rowData['location no_']}/create/edit?FirstDate=${$root.moment($route.query.FirstDate, 'MM/DD/YYYY').day(6).format('MM/DD/YYYY')}`">Create</a>
                                <div v-else><a href="#" @click.prevent.stop="checkAccountStatus">Create</a></div>
                            </div>
                        </div>
                        <div v-else>
                            <div v-if="rowData.saturday_count!=0"><a href="#" @click.prevent.stop="(showDayView={orders:[], dow:'saturday', ...rowData})">View ({{rowData.saturday_count}})</a></div>
                        </div>
                    </template>
                    <!-- Total -->
                    <template #column-9="{ rowData }">
                        {{ rowData.total }}
                    </template>
                </DataTable>
            </div>

            <!-- ======================= ITEM DataTable ======================= -->
            <div v-if="$route.query.SummaryType=='ITEM'" class="item-table-wrapper">
                <DataTable
                    :options="itemTableOptions"
                    :columns="itemColumns"
                    ref="itemTable"
                    class="display table table-sm table-striped table-bordered"
                >
                    <thead>
                        <tr>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Item</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Description</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Monday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Tuesday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Wednesday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Thursday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Friday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Saturday</th>
                            <th style="background-color: var(--bs-gray-700); color: var(--bs-white);">Total</th>
                        </tr>
                        <tr>
                            <td><label class="filter-label">Item</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchItemColumn(0, $event)" /></td>
                            <td><label class="filter-label">Description</label><input type="text" class="form-control form-control-sm" placeholder="Filter..." @input="searchItemColumn(1, $event)" /></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </thead>

                    <!-- Item -->
                    <template #column-0="{ rowData }">
                        <a :href="`${$store.state.api}/pdfs/iteminfo.php?item_no=${rowData.item}`" class="text-black" target="_blank">{{ rowData.item }}</a>
                    </template>
                    <!-- Description -->
                    <template #column-1="{ rowData }">
                        <a :href="`${$store.state.api}/pdfs/iteminfo.php?item_no=${rowData.item}`" class="text-black" target="_blank" v-html="rowData.itmdesc"></a>
                    </template>
                    <!-- Monday -->
                    <template #column-2="{ rowData }">
                        {{ +(rowData['Monday']==0?'0':+(rowData['Monday'])) }}
                    </template>
                    <!-- Tuesday -->
                    <template #column-3="{ rowData }">
                        {{ +(rowData['Tuesday']==0?'0':+(rowData['Tuesday'])) }}
                    </template>
                    <!-- Wednesday -->
                    <template #column-4="{ rowData }">
                        {{ +(rowData['Wednesday']==0?'0':+(rowData['Wednesday'])) }}
                    </template>
                    <!-- Thursday -->
                    <template #column-5="{ rowData }">
                        {{ +(rowData['Thursday']==0?'0':+(rowData['Thursday'])) }}
                    </template>
                    <!-- Friday -->
                    <template #column-6="{ rowData }">
                        {{ +(rowData['Friday']==0?'0':+(rowData['Friday'])) }}
                    </template>
                    <!-- Saturday (visibility controlled by columnDefs) -->
                    <template #column-7="{ rowData }">
                        {{ +(rowData['Saturday']==0?'0':+(rowData['Saturday'])) }}
                    </template>
                    <!-- Total -->
                    <template #column-8="{ rowData }">
                        {{ +(rowData['TOTAL']==0?'0':+(rowData['TOTAL'])) }}
                    </template>
                </DataTable>
            </div>

            <!-- Totals Summary -->
            <div data-intro="Item quantity totals by day" class="">
                <History :canOrderSaturday="canOrderSaturday" :type="$route.query.SummaryType" :rows="summaryRows" />
            </div>

        </div>

        <!-- Day View Modal -->
        <teleport to="body"  v-if="showDayView">
            <div class="modal show" id="myModal" style="display:block;">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title">Orders for
                            <span v-if="showDayView.dow=='sunday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(0).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='monday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(1).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='tuesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(2).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='wednesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(3).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='thursday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(4).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='friday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(5).format('MM/DD/YYYY')}}</span>
                            <span v-else-if="showDayView.dow=='saturday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(6).format('MM/DD/YYYY')}}</span>
                        </h4>
                        <button type="button" class="btn-close"  @click.prevent.stop="showDayView=false"></button>
                    </div>

                    <!-- Modal body -->
                    <div class="modal-body">
                        <div class="text-center p-3" v-if="(showDayView.orders.length==0)" style="line-height:1.2">
                            <div class="mb-3 text-start">
                                <small>
                                    <b>Fetching Orders for: </b><br>
                                    <span v-if="showDayView.dow=='sunday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(0).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='monday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(1).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='tuesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(2).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='wednesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(3).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='thursday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(4).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='friday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(5).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='saturday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(6).format('MM/DD/YYYY')}}</span><br>
                                    Location Number: {{showDayView['location no_']}}<br>
                                    Route Number: {{showDayView['route no_']}}<br>
                                </small>
                            </div>
                            <div class="spinner-border" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                        <div v-else>
                            <div class="mb-3">
                                <small>
                                    <b>Orders for: </b><br>
                                    <span v-if="showDayView.dow=='sunday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(0).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='monday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(1).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='tuesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(2).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='wednesday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(3).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='thursday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(4).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='friday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(5).format('MM/DD/YYYY')}}</span>
                                    <span v-else-if="showDayView.dow=='saturday'">{{$root.moment($route.query.FirstDate,'MM/DD/YYYY').day(6).format('MM/DD/YYYY')}}</span><br>
                                    Location Number: {{showDayView['location no_']}}<br>
                                    Route Number: {{showDayView['route no_']}}<br>
                                </small>
                            </div>
                            <table class="w-100 table table-bordered table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th title="Doc #" class="text-white" style=" background-color: var(--bs-gray-700);">
                                            <span>Doc #</span>
                                        </th>
                                        <th title="Used On Day" class="text-white" style=" background-color: var(--bs-gray-700);">
                                            <span>Used On Day</span>
                                        </th>
                                        <th title="Qty" class="text-white" style=" background-color: var(--bs-gray-700);">
                                            <span>Qty</span>
                                        </th>
                                        <th title="" class="text-white text-end" style=" width:75px; background-color: var(--bs-gray-700);">
                                            <span></span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(order,j) in showDayView.orders" :key="j">
                                        <td class="align-middle"><a class="text-dark text-decoration-none" target="_blank" :href="`/orders/${showDayView['route no_']}/${showDayView['location no_']}/${order['document no_']}/edit`">{{order['document no_']}}</a></td>
                                        <td class="align-middle"><a class="text-dark text-decoration-none" target="_blank" :href="`/orders/${showDayView['route no_']}/${showDayView['location no_']}/${order['document no_']}/edit`">{{order['used on day']}}</a></td>
                                        <td class="align-middle"><a class="text-dark text-decoration-none" target="_blank" :href="`/orders/${showDayView['route no_']}/${showDayView['location no_']}/${order['document no_']}/edit`">{{order['qty']}}</a></td>
                                        <td class="text-end align-middle"><a target="_blank" :href="`/orders/${showDayView['route no_']}/${showDayView['location no_']}/${order['document no_']}/edit?FirstDate=${$root.moment(order['document date'].date).format('MM/DD/YYYY')}`" class="btn btn-secondary btn-sm">{{ showDayView.past_add_cut[(showDayView.dow=='thursday'?'R':showDayView.dow[0].toUpperCase())] == 'true' ? 'View':'Edit' }}</a></td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="mt-2 text-center"  v-if="!isPastAddCut(showDayView)">
                                <div v-if="$root.getCustomerValue('Web Orders Allowed Count')>showDayView.orders.length">
                                    <a class="btn btn-secondary btn-sm" target="_blank" :href="`/orders/${showDayView['route no_']}/${showDayView['location no_']}/create/edit?FirstDate=${$root.moment(showDayView.orders[0]['document date'].date).day(['sunday','monday','tuesday','wednesday','thursday','friday','saturday'][['sunday','monday','tuesday','wednesday','thursday','friday','saturday'].indexOf(showDayView.dow)]).format('MM/DD/YYYY')}`">Create New Order</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click.prevent.stop="showDayView=false">Close</button>
                    </div>
                    </div>
                </div>
            </div>
            <div class="modal-backdrop show"></div>
        </teleport>
    </PageContent>
  </template>

  <script>
    import PageContent from '@/components/PageContent.vue';
    import NotReady from '@/components/NotReady.vue';
    import PageTitle from '@/components/PageTitle.vue';
    import Help from '@/components/Help.vue';
    import History from '@/components/OrderSummary/History.vue';
    import DataTable from 'datatables.net-vue3';
    import DataTablesCore from 'datatables.net-bs5';
    import axios from 'axios';

    DataTable.use(DataTablesCore);

  export default {
    name: 'OrderSummary',
    components: {PageContent, PageTitle, NotReady, History, Help, DataTable},
    watch:{
        showDayView:async function(newVal, oldVal){
            if(newVal != false && newVal.orders.length==0){
                let res = await axios.get(`${this.$store.state.api}/ordersbyday?lccustno=${newVal['customer no_']}&location_no=${newVal['location no_']}&route_no=${newVal['route no_']}&orderdate=${(()=>{
                    let date = '';
                    if(newVal.dow=='sunday') date = this.$root.moment(this.$route.query.FirstDate).day(0).format('MM/DD/YYYY');
                    if(newVal.dow=='monday') date = this.$root.moment(this.$route.query.FirstDate).day(1).format('MM/DD/YYYY');
                    if(newVal.dow=='tuesday') date = this.$root.moment(this.$route.query.FirstDate).day(2).format('MM/DD/YYYY');
                    if(newVal.dow=='wednesday') date = this.$root.moment(this.$route.query.FirstDate).day(3).format('MM/DD/YYYY');
                    if(newVal.dow=='thursday') date = this.$root.moment(this.$route.query.FirstDate).day(4).format('MM/DD/YYYY');
                    if(newVal.dow=='friday') date = this.$root.moment(this.$route.query.FirstDate).day(5).format('MM/DD/YYYY');
                    if(newVal.dow=='saturday') date = this.$root.moment(this.$route.query.FirstDate).day(6).format('MM/DD/YYYY');
                    return date;
                })()}`);
                newVal.orders = res;
            }
        }
    },
    data(){
        return {
            _:_,
            ready:false,
            canOrderSaturday:false,
            showDayView:false,
            // Summary rows for the History component totals (fed from API response)
            summaryRows: [],
        }
    },
    async mounted(){
        if(this.$route.query.FirstDate==undefined) this.$route.query.FirstDate = this.$root.moment().startOf('week').format('MM/DD/YYYY');
        this.ready = true;
    },
    computed:{
        firstDate(){
            return this.$route.query.FirstDate ? this.$route.query.FirstDate : this.$root.moment().day(0).format('MM/DD/YYYY');
        },
        locationColumns(){
            let cols = [
                { data: 'route no_' },
                { data: 'location no_' },
                { data: 'name' },
                { data: 'monday_count' },
                { data: 'tuesday_count' },
                { data: 'wednesday_count' },
                { data: 'thursday_count' },
                { data: 'friday_count' },
                { data: 'saturday_count' },
                { data: 'total' },
            ];
            return cols;
        },
        locationTableOptions(){
            const self = this;
            return {
                pageLength: this.$store.state.localStorage.user['OrderSummary_Per_Page'] ?? 25,
                lengthMenu: [[25, 50, 100, -1], [25, 50, 100, 'All']],
                layout: {
                    topStart: 'pageLength',
                    topEnd: 'search',
                    top2End: 'paging',
                    bottomStart: 'info',
                    bottomEnd: 'paging',
                },
                scrollX: true,
                scrollY: '60vh',
                scrollCollapse: true,
                orderCellsTop: true,
                processing: true,
                serverSide: true,
                order: [[0, 'asc']],
                autoWidth: false,
                columnDefs: [
                    { targets: '_all', orderSequence: ['asc', 'desc'] },
                    { targets: [0], width: '80px' },   // Route
                    { targets: [1], width: '90px' },   // Location
                    { targets: [2], width: '150px' },   // Description
                    { targets: [3,4,5,6,7], width: '110px' }, // Day columns
                    { targets: [8], visible: self.canOrderSaturday, width: '110px' },
                    { targets: [9], width: '90px' },   // Total
                ],
                ajax: {
                    url: `${this.$store.state.api}/dt/ordersummaryLOCATION?token=${localStorage.token}`,
                    type: 'GET',
                    data: (data) => {
                        return {
                            draw: data.draw,
                            start: data.start,
                            length: data.length,
                            search: data.search.value,
                            orderBy: data.columns[data.order[0].column].data,
                            orderDir: data.order[0].dir,
                            lccustno: this.$root.getCustomerNumber(),
                            FirstDate: this.firstDate,
                            'route_no_': data.columns[0].search.value,
                            'location_no_': data.columns[1].search.value,
                            'name': data.columns[2].search.value,
                        };
                    },
                    dataSrc: (json) => {
                        // Capture totals and canOrderSaturday from the response
                        if(json.totals){
                            self.summaryRows = [{
                                monday_count: json.totals.monday_count,
                                tuesday_count: json.totals.tuesday_count,
                                wednesday_count: json.totals.wednesday_count,
                                thursday_count: json.totals.thursday_count,
                                friday_count: json.totals.friday_count,
                                saturday_count: json.totals.saturday_count,
                                total: json.totals.total,
                            }];
                        }
                        if(json.canOrderSaturday !== undefined){
                            self.canOrderSaturday = json.canOrderSaturday;
                            // Update column visibility dynamically
                            if(self.$refs.locationTable && self.$refs.locationTable.dt){
                                self.$refs.locationTable.dt.column(8).visible(json.canOrderSaturday);
                            }
                        }
                        return json.data;
                    }
                }
            };
        },
        itemColumns(){
            let cols = [
                { data: 'item' },
                { data: 'itmdesc' },
                { data: 'Monday' },
                { data: 'Tuesday' },
                { data: 'Wednesday' },
                { data: 'Thursday' },
                { data: 'Friday' },
                { data: 'Saturday' },
                { data: 'TOTAL' },
            ];
            return cols;
        },
        itemTableOptions(){
            const self = this;
            return {
                pageLength: this.$store.state.localStorage.user['OrderSummaryItem_Per_Page'] ?? 25,
                lengthMenu: [[25, 50, 100, -1], [25, 50, 100, 'All']],
                layout: {
                    topStart: 'pageLength',
                    topEnd: 'search',
                    top2End: 'paging',
                    bottomStart: 'info',
                    bottomEnd: 'paging',
                },
                scrollX: true,
                scrollY: '60vh',
                scrollCollapse: true,
                orderCellsTop: true,
                processing: true,
                serverSide: true,
                order: [[0, 'asc']],
                columnDefs: [
                    { targets: '_all', orderSequence: ['asc', 'desc'] },
                    { targets: [7], visible: self.canOrderSaturday },
                ],
                ajax: {
                    url: `${this.$store.state.api}/dt/ordersummaryITEM?token=${localStorage.token}`,
                    type: 'GET',
                    data: (data) => {
                        return {
                            draw: data.draw,
                            start: data.start,
                            length: data.length,
                            search: data.search.value,
                            orderBy: data.columns[data.order[0].column].data,
                            orderDir: data.order[0].dir,
                            lccustno: this.$root.getCustomerNumber(),
                            FirstDate: this.firstDate,
                            'item': data.columns[0].search.value,
                            'itmdesc': data.columns[1].search.value,
                        };
                    },
                    dataSrc: (json) => {
                        if(json.totals){
                            self.summaryRows = [{
                                Monday: json.totals.Monday,
                                Tuesday: json.totals.Tuesday,
                                Wednesday: json.totals.Wednesday,
                                Thursday: json.totals.Thursday,
                                Friday: json.totals.Friday,
                                Saturday: json.totals.Saturday,
                                TOTAL: json.totals.TOTAL,
                            }];
                        }
                        if(json.canOrderSaturday !== undefined){
                            self.canOrderSaturday = json.canOrderSaturday;
                            if(self.$refs.itemTable && self.$refs.itemTable.dt){
                                self.$refs.itemTable.dt.column(7).visible(json.canOrderSaturday);
                            }
                        }
                        return json.data;
                    }
                }
            };
        },
    },
    methods:{
        checkAccountStatusBool(){
            if(localStorage.account_status!='Credit Hold (Over Limit)'){
                return true;
            }
            else{
                return false;
            }
        },
        async checkAccountStatus(e){
            let url = e.target.href;
            if(localStorage.account_status!='Credit Hold (Over Limit)'){
                this.$router.push(url.replace('http://localhost:8080','').replace('http://localhost:8081','').replace('https://orders.kffoods.com','').replace('https://dev.kffoods.com',''));
            }
            else{
                this.$root.showToast(['alert', 'alert-danger', 'bg-danger'], 'Credit Hold: You cannot place an order at this time.');
                e.preventDefault();
            }
        },
        isPastAddCut(d){
            let letter;
            let day;
            day = (this.$root.moment(d.orders[0]['document date'].date).format('ddd'))
            if(day=='Thu') letter = 'R';
            else letter = day[0];

            if(d.past_add_cut[letter]=='true') return true;
            else return false;
        },
        searchLocationColumn: _.debounce(function(colIndex, event){
            this.$refs.locationTable.dt.column(colIndex).search(event.target.value).draw();
        }, 300),
        searchItemColumn: _.debounce(function(colIndex, event){
            this.$refs.itemTable.dt.column(colIndex).search(event.target.value).draw();
        }, 300),
    },
  }
  </script>
  <style lang="scss">
    @import 'datatables.net-bs5';

    table.dataTable thead tr th,
    table.dataTable tbody tr td,
    table.dataTable tbody tr th {
        white-space: nowrap !important;
        font-size: 0.85rem;
    }

    table.dataTable thead tr th {
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .filter-label {
        display: none;
        font-size: 0.75rem;
        font-weight: bold;
        text-align: left;
        margin-bottom: 0.2rem;
    }

    @media (max-width: 992px) {
        .filter-label {
            display: block;
        }

        .dt-scroll-body {
            height: auto !important;
        }

        table.dataTable {
            display: block;

            thead {
                display: block;

                tr:first-child {
                    display: none;
                }

                tr:nth-child(2) {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                    padding: 0.5rem;
                    background-color: var(--bs-gray-200);
                    border-bottom: 1px solid var(--bs-gray-300);

                    td {
                        flex: 1 1 45%;
                        padding: 0;

                        input {
                            width: 100%;
                        }

                        &:empty {
                            display: none;
                        }
                    }
                }
            }

            tbody {
                display: block;

                tr {
                    display: block;
                    border: 1px solid var(--bs-gray-300);
                    border-radius: 0.375rem;
                    margin-bottom: 1rem;
                    padding: 0.5rem 0.75rem;

                    td {
                        display: block;
                        width: 100% !important;
                        border: none;
                        padding: 0.15rem 0;
                        white-space: normal !important;
                        text-align: left !important;

                        &:nth-of-type(1)::before {
                            content: 'Route: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(2)::before {
                            content: 'Location: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(3)::before {
                            content: 'Description: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(4)::before {
                            content: 'Monday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(5)::before {
                            content: 'Tuesday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(6)::before {
                            content: 'Wednesday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(7)::before {
                            content: 'Thursday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(8)::before {
                            content: 'Friday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(9)::before {
                            content: 'Saturday: ';
                            font-weight: bold;
                        }
                        &:nth-of-type(10)::before {
                            content: 'Total: ';
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        /* Item table mobile: different labels */
        .item-table-wrapper table.dataTable tbody tr td {
            &:nth-of-type(1)::before {
                content: 'Item: ' !important;
            }
            &:nth-of-type(2)::before {
                content: 'Description: ' !important;
            }
            &:nth-of-type(3)::before {
                content: 'Monday: ' !important;
            }
            &:nth-of-type(4)::before {
                content: 'Tuesday: ' !important;
            }
            &:nth-of-type(5)::before {
                content: 'Wednesday: ' !important;
            }
            &:nth-of-type(6)::before {
                content: 'Thursday: ' !important;
            }
            &:nth-of-type(7)::before {
                content: 'Friday: ' !important;
            }
            &:nth-of-type(8)::before {
                content: 'Saturday: ' !important;
            }
            &:nth-of-type(9)::before {
                content: 'Total: ' !important;
            }
        }
    }
  </style>
